module.exports = __webpack_public_path__ + "img/cyan_five_petal_flower_large_eyes.cb074851.png";